import { AddressBadge, TxHashBadge } from './AddressBadge';
import { timeAgo, getTokenColor } from '../lib/utils';
import { Skeleton } from './ui/skeleton';
import { Badge } from './ui/badge';

const TRACKED_TOKENS = {
  "0x9189d145d1d8e612c4c48bbd1af5a50cbee63d7d": { symbol: "KROWN", isNative: true },
  "0xa3d9cfa4220d6a5ba7b9067d33ebedbd2de6f1cf": { symbol: "USDC" },
  "0x59973ae98d340ca0577ed92502402e82e987ba2e": { symbol: "USDT" },
  "0x6f9ec4f83ef69b923fa1dc00189e591728df0ac0": { symbol: "ETH" },
};

export function TransfersTable({ transfers, loading, showToken = false, currentAddress = null }) {
  if (loading) {
    return (
      <div className="table-container rounded-lg border">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tx Hash</th>
              {showToken && <th>Token</th>}
              <th>From</th>
              {currentAddress && <th className="text-center">Direction</th>}
              <th>To</th>
              <th className="text-right">Amount</th>
              <th className="text-right">Time</th>
            </tr>
          </thead>
          <tbody>
            {['a', 'b', 'c', 'd', 'e'].map((k) => (
              <tr key={k}>
                <td><Skeleton className="h-6 w-28" /></td>
                {showToken && <td><Skeleton className="h-6 w-16" /></td>}
                <td><Skeleton className="h-6 w-24" /></td>
                {currentAddress && <td><Skeleton className="h-6 w-12 mx-auto" /></td>}
                <td><Skeleton className="h-6 w-24" /></td>
                <td><Skeleton className="h-6 w-20 ml-auto" /></td>
                <td><Skeleton className="h-6 w-16 ml-auto" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (!transfers || transfers.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No transfers found</p>
      </div>
    );
  }

  // Determine if transfer is IN or OUT based on current address
  const getDirection = (transfer) => {
    if (!currentAddress) return null;
    const normalizedCurrent = currentAddress.toLowerCase();
    const from = transfer.from_address?.toLowerCase();
    const to = transfer.to_address?.toLowerCase();
    
    if (to === normalizedCurrent) return 'IN';
    if (from === normalizedCurrent) return 'OUT';
    return null;
  };

  return (
    <div className="table-container rounded-lg border">
      <table className="data-table">
        <thead>
          <tr>
            <th>Tx Hash</th>
            {showToken && <th>Token</th>}
            <th>From</th>
            {currentAddress && <th className="text-center">Direction</th>}
            <th>To</th>
            <th className="text-right">Amount</th>
            <th className="text-right">Time</th>
          </tr>
        </thead>
        <tbody>
          {transfers.map((transfer, idx) => {
            const tokenInfo = TRACKED_TOKENS[transfer.token_address] || {};
            const colors = getTokenColor(tokenInfo.symbol);
            const direction = getDirection(transfer);
            
            return (
              <tr key={`${transfer.tx_hash}-${transfer.log_index}-${idx}`} className="animate-fade-in">
                <td>
                  <TxHashBadge hash={transfer.tx_hash} />
                </td>
                {showToken && (
                  <td>
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${colors.bg} ${colors.text}`}>
                      {tokenInfo.symbol || 'Unknown'}
                    </span>
                  </td>
                )}
                <td>
                  <AddressBadge address={transfer.from_address} />
                </td>
                {currentAddress && (
                  <td className="text-center">
                    {direction && (
                      <Badge 
                        className={`text-xs font-bold ${
                          direction === 'IN' 
                            ? 'bg-emerald-500/20 text-emerald-600 border-emerald-500/30' 
                            : 'bg-amber-500/20 text-amber-600 border-amber-500/30'
                        }`}
                      >
                        {direction}
                      </Badge>
                    )}
                  </td>
                )}
                <td>
                  <AddressBadge address={transfer.to_address} />
                </td>
                <td className="text-right font-mono">
                  {transfer.amount_formatted}
                </td>
                <td className="text-right text-muted-foreground text-sm">
                  {timeAgo(transfer.block_time)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
